import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const AGB = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <Breadcrumbs items={[{ label: "Allgemeine Geschäftsbedingungen" }]} />
          <h1 className="break-words text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-8">
            Allgemeine Geschäftsbedingungen
          </h1>

          <div className="space-y-8 text-foreground">
            <div className="mb-6">
              <p className="text-lg font-semibold text-foreground">
                Allgemeine Geschäftsbedingungen der EAP® Produktions- und Patentverwertungs-GmbH
              </p>
              <p className="text-sm text-muted-foreground mt-2">Stand: August 2026 (Version 2.0)</p>
            </div>

            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Geltung</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  1.1 Diese Geschäftsbedingungen gelten zwischen uns der EAP® Produktions- und Patentverwertungs-GmbH (Hauptsitz und Produktionsstandort) und natürlichen und juristischen Personen (kurz Kunde), ausschließlich Zahnärzte oder Zahntechniker, für das gegenständliche unternehmensbezogene Rechtsgeschäft sowie auch für alle hinkünftigen Geschäfte, selbst wenn im Einzelfall, insbesondere bei künftigen Ergänzungs- oder Folgeaufträgen darauf nicht ausdrücklich Bezug genommen wurde.
                </p>
                <p>
                  1.2 Es gilt jeweils die bei Vertragsabschluss aktuelle Fassung unserer AGB, abrufbar auf unserer Homepage https://eap-abutments.com/AGBs und wurden somit auch an den Kunden übermittelt.
                </p>
                <p>
                  1.3. Wir kontrahieren ausschließlich unter Zugrundelegung unserer AGB.
                </p>
                <p>
                  1.4. Geschäftsbedingungen des Kunden oder Änderungen bzw. Ergänzungen unserer AGB bedürfen zu ihrer Geltung unserer ausdrücklichen schriftlichen Zustimmung.
                </p>
                <p>
                  1.5. Geschäftsbedingungen des Kunden werden auch dann nicht anerkannt, wenn wir ihnen nach Eingang bei uns nicht ausdrücklich widersprechen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Angebote, Vertragsabschluss</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  2.1. Unsere Angebote sind unverbindlich.
                </p>
                <p>
                  2.2. Zusagen, Zusicherungen und Garantien unsererseits oder von diesen AGB abweichende Vereinbarungen im Zusammenhang mit dem Vertragsabschluss werden erst durch unsere schriftliche Bestätigung verbindlich.
                </p>
                <p>
                  2.3. In Katalogen, Preislisten, Prospekten, Anzeigen auf Messeständen, Rundschreiben, Werbeaussendungen oder anderen Medien (Informationsmaterial) angeführte Informationen über unsere Produkte und Leistungen, die nicht uns zuzurechnen sind, hat der Kunde – sofern der Kunde diese seiner Entscheidung zur Beauftragung zugrunde legt – uns darzulegen. Diesfalls können wir zu deren Richtigkeit Stellung nehmen. Verletzt der Kunde diese Obliegenheit, sind derartige Angaben unverbindlich, soweit diese nicht ausdrücklich schriftlich zum Vertragsinhalt erklärt wurden.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Preise</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  3.1. Preisangaben verstehen sich zuzüglich der jeweils geltenden gesetzlichen Umsatzsteuer und ab Werk. Versandkosten sowie Zoll und Versicherung gehen zu Lasten des Kunden.
                </p>
                <p>
                  3.2. Für vom Kunden angeordnete Leistungen, die im ursprünglichen Auftrag keine Deckung finden, insbesondere fehlerhafte oder beschädigte STL-Dateien, werden € 50 als Mehraufwand als Entgelt verrechnet.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Zahlung</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  4.1. 100% des Entgeltes wird bei Vertragsabschluss fällig.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Upload der obligatorischen STL-Files und eventuell vorhandener Meta-Daten</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  5.1. Unsere Pflicht zur Leistungsausführung beginnt frühestens, sobald alle technischen Einzelheiten in unserem Bestellportal eingetragen sind (Implantat Hersteller, Implantatsystem, Regio, Durchmesser, Patient und Arzt) sowie des vollständige Upload der STL-Daten erfolgt ist.
                </p>
                <p>
                  5.2. Für Konstruktion und Funktionsfähigkeit von beigestellten Abutments trägt der Kunde allein die Verantwortung. Eine Kontrolle der Teile unterliegt im offensichtlichen Fall einer Fehlkonstruktion unseren technisch validierten Prozessen, die im Zweifel von angewandt und damit das STL-File verändert wird.
                </p>
                <p>
                  5.3. Der Kunde ist nicht berechtigt, Forderungen und Rechte aus dem Vertragsverhältnis ohne unsere schriftliche Zustimmung abzutreten.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Leistungsausführung</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  6.1. Nachträgliche Änderungen sind ausgeschlossen, da sich ab dem Zeitpunkt des Uploads, der automatische Prozess der Produktion beginnt.
                </p>
                <p>
                  6.2. Wünscht der Kunde nach Vertragsabschluss eine Leistungsausführung innerhalb eines kürzeren Zeitraums, stellt dies eine Vertragsänderung dar. Hierdurch können Überstunden notwendig werden und/oder durch die Beschleunigung der Materialbeschaffung Mehrkosten auflaufen, und erhöht sich das Entgelt im Verhältnis zum notwendigen Mehraufwand angemessen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Liefer- und Leistungsfristen</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>7.1. Typische Lieferfrist innerhalb Österreichs 3 Werktage</p>
                <p>7.2. Typische Lieferfrist innerhalb der EU 5 Werktage</p>
                <p>7.3. Typische Lieferfrist weltweit innerhalb von 10 Werktagen</p>
                <p>7.4. Aufträge werden unmittelbar nach Eingang bearbeitet.</p>
                <p>
                  7.5. Liefer-/Leistungsfristen und -Termine sind für uns nur verbindlich, sofern sie schriftlich festgelegt wurden. Ein Abgehen von dieser Formvorschrift bedarf ebenfalls der Schriftlichkeit.
                </p>
                <p>
                  7.6. Fristen und Termine verschieben sich bei höherer Gewalt, Streik, nicht vorhersehbarer und von uns nicht verschuldeter Verzögerung durch unsere Zulieferer oder sonstigen vergleichbaren Ereignissen, die nicht in unserem Einflussbereich liegen, in jenem Zeitraum, währenddessen das entsprechende Ereignis andauert. Davon unberührt bleibt das Recht des Kunden auf Rücktritt vom Vertrag bei Verzögerungen die eine Bindung an den Vertrag unzumutbar machen.
                </p>
                <p>
                  7.7. Beim Rücktritt vom Vertrag wegen Verzug hat vom Kunden eine Nachfristsetzung mittels eingeschriebenen Briefes unter gleichzeitiger Androhung des Rücktritts zu erfolgen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Unser geistiges Eigentum</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  8.1. Informationsmaterial bleibt unser geistiges Eigentum.
                </p>
                <p>
                  8.2. Deren Verwendung, insbesondere deren Vervielfältigung, Veröffentlichung und Zur-Verfügung-Stellung einschließlich auch nur auszugsweisen Kopierens, wie auch deren Nachahmung, Bearbeitung oder Verwertung bedarf unserer ausdrücklichen Zustimmung.
                </p>
                <p>
                  8.3. Der Kunde verpflichtet sich weiters zur Geheimhaltung des ihm aus der Geschäftsbeziehung zugegangenen Wissens Dritten gegenüber.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Gewährleistung und freiwillige Sondergarantie</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  9.1 Die Gewährleistungsfrist für unsere Leistungen beträgt ein Jahr ab Übergabe.
                </p>
                <p>
                  9.2. Darüber hinaus gewähren wir eine Sondergarantie von 10 Jahren für unsere EAP® Hybridabutments, die nicht manipuliert wurden.
                </p>
                <p>
                  9.3. Behebungen eines vom Kunden behaupteten Mangels stellen kein Anerkenntnis eines Mangels dar.
                </p>
                <p>
                  9.4. Der Kunde hat stets zu beweisen, dass der Mangel zum Zeitpunkt der Übergabe bereits vorhanden war.
                </p>
                <p>
                  9.5. Wir sind berechtigt, jede von uns für notwendig erachtete Untersuchung anzustellen oder anstellen zu lassen, auch wenn durch diese die Waren oder Werkstücke unbrauchbar gemacht werden. Für den Fall, dass diese Untersuchung ergibt, dass wir keine Fehler zu vertreten haben, hat der Kunde die Kosten für diese Untersuchung gegen angemessenes Entgelt zu tragen.
                </p>
                <p>
                  9.6. Zur Mängelbehebung sind uns seitens des Kunden zumindest zwei Versuche einzuräumen.
                </p>
                <p>
                  9.7. Ein Wandlungsbegehren können wir durch Verbesserung oder angemessene Preisminderung abwenden, sofern es sich um keinen wesentlichen und unbeheb­baren Mangel handelt.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Haftung</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  10.1. Wegen Verletzung vertraglicher oder vorvertraglicher Pflichten, insbesondere wegen Unmöglichkeit, Verzug etc. haften wir bei Vermögensschäden nur in Fällen von Vorsatz oder grober Fahrlässigkeit aufgrund technischer Besonderheiten.
                </p>
                <p>
                  10.2. Die Haftung ist beschränkt mit dem Haftungshöchstbetrag einer allenfalls durch uns abgeschlossenen Haftpflichtversicherung.
                </p>
                <p>
                  10.3. Diese Beschränkung gilt auch hinsichtlich des Schadens an einer Sache, die wir zur Bearbeitung übernommen haben.
                </p>
                <p>
                  10.4. Schadenersatzansprüche sind bei sonstigem Verfall binnen zwei Jahren gerichtlich geltend zu machen.
                </p>
                <p>
                  10.5. Die Beschränkungen bzw. Ausschlüsse der Haftung umfasst auch Ansprüche gegen unsere Mitarbeiter, Vertreter und Erfüllungsgehilfe aufgrund Schädigungen, die diese dem Kunden ohne Bezug auf einen Vertrag ihrerseits mit dem Kunden zufügen.
                </p>
                <p>
                  10.6. Unsere Haftung ist ausgeschlossen für Schäden durch unsachgemäße Behandlung und Überbeanspruchung.
                </p>
                <p>
                  10.7. Wenn und soweit der Kunde für Schäden, für die wir haften, Versicherungsleistungen durch eine eigene oder zu seinen Gunsten abgeschlossen Schadenversicherung (zB Haftpflichtversicherung, Kasko, Transport, Feuer, Betriebsunterbrechung und andere) in Anspruch nehmen kann, verpflichtet sich der Kunde zur Inanspruchnahme der Versicherungsleistung und beschränkt sich unsere Haftung gegenüber dem Kunden insoweit auf die Nachteile, die dem Kunden durch die Inanspruchnahme dieser Versicherung entstehen (z.B. höhere Versicherungsprämie).
                </p>
                <p>
                  10.8. Jene Produkteigenschaften werden geschuldet, die im Hinblick auf die Zulassungsvorschriften, Bedienungsanleitungen und sonstige produktbezogene Anleitungen und Hinweise (insb. auch Kontrolle und Wartung) von uns, dritten Herstellern oder Importeuren vom Kunden unter Berücksichtigung dessen Kenntnisse und Erfahrungen erwartet werden können. Der Kunde als Weiterverkäufer hat eine ausreichende Versicherung für Produkthaftungsansprüche abzuschließen und uns hinsichtlich Regressansprüchen schad- und klaglos zu halten.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Salvatorische Klausel</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>
                  11.1. Sollten einzelne Teile dieser AGB unwirksam sein, so wird dadurch die Gültigkeit der übrigen Teile nicht berührt.
                </p>
                <p>
                  11.2. Die Parteien verpflichten sich jetzt schon eine Ersatzregelung – ausgehend vom Horizont redlicher Vertragsparteien – zu treffen, die dem wirtschaftlichen Ergebnis unter Berücksichtigung der Branchenüblichkeit der unwirksamen Bedingung am nächsten kommt.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">12. Allgemeines</h2>
              <div className="space-y-3 text-muted-foreground leading-relaxed">
                <p>12.1. Es gilt österreichisches Recht.</p>
                <p>12.2. Das UN-Kaufrecht ist ausgeschlossen.</p>
                <p>12.3. Erfüllungsort ist der Sitz des Unternehmens in Hall in Tirol, Österreich</p>
                <p>12.4. Gerichtsstand für alle sich aus dem Vertragsverhältnis oder künftigen Verträgen zwischen uns und dem Kunden ergebenden Streitigkeiten ist das für unseren Sitz örtlich zuständige Gericht.</p>
                <p>12.5. Änderungen seines Namens, der Firma, seiner Anschrift, seiner Rechtsform oder andere relevante Informationen hat der Kunde uns umgehend schriftlich bekannt zu geben.</p>
              </div>
            </section>

            <div className="pt-8 border-t border-border">
              <p className="text-sm text-muted-foreground">
                Stand: August 2026 (Version 2.0)<br />
                Ersetzt die Fassung Stand Mai 2024 (archiviert).<br />
                EAP® Produktions- und Patentverwertungs-GmbH<br />
                Lorettostraße 26 | 6060 Hall in Tirol | Austria
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AGB;
